module.exports = __webpack_public_path__ + "img/bag.b24ecfb2.png";